
<script>
	
</script>
<style>
	.tabs{
		min-height:calc(100% - 75px);
		height: calc(100% - 75px);
		min-width:100%;
	}
</style>
<div class="tabs">
	<slot></slot>
</div>